import { render, staticRenderFns } from "./new-sole-good-billon.vue?vue&type=template&id=a754c66e&scoped=true"
import script from "./new-sole-good-billon.vue?vue&type=script&lang=js"
export * from "./new-sole-good-billon.vue?vue&type=script&lang=js"
import style0 from "./new-sole-good-billon.vue?vue&type=style&index=0&id=a754c66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a754c66e",
  null
  
)

export default component.exports